import { render, staticRenderFns } from "./StickersView.vue?vue&type=template&id=c3891164&scoped=true&"
import script from "./StickersView.vue?vue&type=script&lang=js&"
export * from "./StickersView.vue?vue&type=script&lang=js&"
import style0 from "./StickersView.vue?vue&type=style&index=0&id=c3891164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3891164",
  null
  
)

export default component.exports